// Merry Maids extras are stored one row per unit (as SM stores cleaning
// services), so an extra booked × 3 comes back from the API as three rows.
// These fold rows back into quantities, and build the basket the API prices.

export interface MmExtraGroup {
    online_product: any;
    quantity: number;
    rows: any[];
}

export function groupMmExtras(rows: any[]): MmExtraGroup[] {
    const groups: MmExtraGroup[] = [];
    (rows || []).forEach((row) => {
        if (!row?.online_product) {
            return;
        }
        const group = groups.find((existing) => existing.online_product.id === row.online_product.id);
        if (group) {
            group.quantity++;
            group.rows.push(row);
        } else {
            groups.push({online_product: row.online_product, quantity: 1, rows: [row]});
        }
    });
    return groups;
}

export function mmSelectedProducts(mainId: number | null, extras: { id: number, quantity: number }[]): { id: number, quantity?: number }[] {
    const selectedProducts: { id: number, quantity?: number }[] = [];
    if (mainId) {
        selectedProducts.push({id: mainId});
    }
    (extras || []).forEach((extra) => {
        selectedProducts.push({id: extra.id, quantity: extra.quantity});
    });
    return selectedProducts;
}
